export enum GlobalRegistrationRoutes {
  BASE = 'register',
  EMAIL = 'email',
  ACCOUNT = 'account'
}
